import { render } from "./full_pediatrics_head.vue?vue&type=template&id=ff1cc6de&scoped=true"
import script from "./full_pediatrics_head.vue?vue&type=script&lang=js"
export * from "./full_pediatrics_head.vue?vue&type=script&lang=js"

import "./full_pediatrics_head.vue?vue&type=style&index=0&id=ff1cc6de&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1cc6de"]])

export default __exports__